/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1Icon16Solid = forwardRef('People1Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
        React.createElement("path", { d: "M2.137 12.607C2.857 9.24 6.235 9 8 9c1.765 0 5.143.24 5.863 3.607.162.756-.49 1.393-1.263 1.393H3.4c-.773 0-1.425-.637-1.263-1.393Z" })));
});
